import { useMutation } from "react-query";

import type { AvpError } from "@jti/fe-common";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { CasAuthApi } from "../../../services";

type ForgotPasswordResponse = {
  message: string;
};

export const useForgotPassword = () => {
  return useMutation<ForgotPasswordResponse, AvpError, string>(MUTATION_KEYS.forgotPassword, (email: string) =>
    CasAuthApi.init().forgotPassword(email)
  );
};
